---
seo:
  title: Sending Messages to a Practice | Patient Portal
  description: |
    Information for patients to send messages to a practice
---

# Sending messages to a practice

If you have any questions for a practice, you can send a message directly to
them via the patient portal.

## Sending a message

To send a message to the practice:

- [log into the patient portal](../../logging-in)
- do either one of the following:
  - click **Send a message** in the primary navigation, or
  - click **Messages** in the primary navigation and then click **New Message**
    on the page listing the messages already sent
- enter your message
- click **Send** on the form

An email will be sent to the practice, after which they'll reach out to you for
further communication.

## Viewing your messages

To view all of your messages:

- [log into the patient portal](../../logging-in)
- click **Messages** in the primary navigation

If the practice responds to you via Hugo Systems, you will receive an email with
their response, and that response will also be shown on this page.

## Deleting messages

If you're not happy with a message you sent, you can delete it by clicking
**Delete** on the message from the page listing your sent messages.

The practice will see that you deleted the message, and that you do not want
feedback for that message.

Please note that by sending a message the practice
will receive an email from Hugo Systems containing your message. Deleting a
message after it has been created will not prevent the practice from seeing your
original message.
